// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__0RxP_","rotation":"Loader_rotation__je6OL","inverted":"Loader_inverted__6Q2kl"};